import React, { useState, useEffect } from 'react';
import styles from './Rules.module.css';

import LayoutDefault from '../../../Components/LayoutDefault/LayoutDefault';
import Panel from '../../../Components/Panel/Panel';
import PanelListDefault from '../../../Components/PanelListDefault/PanelListDefault';
import RemoveIdsNotFound from '../../../Components/RemoveIdsNotFound/RemoveIdsNotFound';
import ExecuteAxios from '../../../Components/ExecuteAxios/ExecuteAxios';
import ResetVariables from '../../../Components/ResetVariables/ResetVariables';
import ApplyAttributes from '../../../Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from '../../../Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import { useContext } from 'react';
import { AuthContext } from '../../../Contexts/auth';
import InputField from '../../../Components/Input/InputField';
import LoadingIndicator from '../../../Components/LoadingIndicator/LoadingIndicator';

function Rules({
    subjectRuleId,
    setSelectedsRules,
    selectedsRules,
    reloadRules,
    setReloadRules
}) {
    const { clientSelected, clientSelectedHandled, setClientSelectedHandled } = useContext(AuthContext);
    const [id, setId] = useState(null)
    const [question, setQuestion] = useState(null);
    const [answer, setAnswer] = useState(null);
    const [isActive, setIsActive] = useState('S')

    const [rulesRecords, setRulesRecords] = useState(null)
    const [inserting, setInserting] = useState(false)
    const [updating, setUpdating] = useState(false)
    const [loadingPanel, setLoadingPanel] = useState(false)

    const [descriptionFilter, setDescriptionFilter] = useState(null)

    const attributeList = [
        { name: "id", value: id, setter: setId },
        { name: "question", value: question, setter: setQuestion, style: { height: '250px' }, width: '220px' },
        { name: "answer", value: answer, setter: setAnswer, style: { height: '250px' }, width: '220px' },
        { name: "subjectRuleId", value: subjectRuleId, setter: null, isMandatory: 'N', isVisible: 'N' },
        {
            name: "isActive", value: isActive, setter: setIsActive, defaultValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
    ];

    const callToGetRulesGrid = (async () => {
        setInserting(false)
        setUpdating(false)
        if (subjectRuleId && clientSelected) {
            await getRulesGrid()
        }
    })

    useEffect(() => {
        setLoadingPanel(true)
        getRulesGrid()
        setLoadingPanel(false)
    }, []);

    useEffect(() => {
        if (reloadRules) {
            setReloadRules(false)
            setLoadingPanel(true)
            callToGetRulesGrid()
            setLoadingPanel(false)
        }
    }, [reloadRules]);

    useEffect(() => {
        setLoadingPanel(true)
        callToGetRulesGrid()
        setLoadingPanel(false)
    }, [subjectRuleId]);

    useEffect(() => {
        if (!clientSelected || !clientSelectedHandled) return
        setLoadingPanel(true)
        setClientSelectedHandled(false)
        callToGetRulesGrid()
        setLoadingPanel(false)
    }, [clientSelectedHandled, subjectRuleId, descriptionFilter]);

    async function getRulesGrid() {
        const status = ['A'];
        const parameters = {
            clientId: clientSelected ?? 0,
            subjectRuleId: subjectRuleId ?? 0,
            descriptionFilter: descriptionFilter,
            isStatus: status.join(",")
        }
        const rulesRecordsResponse = await ExecuteAxios.api('get', `/condominium-rules/get-condominium-rules-grid/`, { params: parameters });
        setRulesRecords(rulesRecordsResponse);
        RemoveIdsNotFound.remove(rulesRecordsResponse, setSelectedsRules, selectedsRules)
    }

    const inputDescriptionFilter = () => {
        return (
            <InputField
                setAttribute={setDescriptionFilter}
                value={descriptionFilter}
                readOnly={false}
                disabled={false}
                style={{ marginLeft: '10px', width: '150px', borderRadius: '4px' }}
            />
        )
    }

    const panelsStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%'
    };

    return (
        <Panel
            style={{ ...panelsStyle }}
            titlePage={'Regras'}
            canViewCRUD={true}
            recordsSelected={[]}
            viewOnlyOneRecordCRUD={false}
            resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
            dataListedAttributes={rulesRecords}
            attributeList={attributeList}
            onUpdateIdSelected={setSelectedsRules}
            componentRightFilter={inputDescriptionFilter()}
        >
            <LoadingIndicator loaded={rulesRecords && !loadingPanel}>
                <PanelListDefault
                    onUpdateIdSelected={setSelectedsRules}
                    idsSelected={selectedsRules}
                    data={rulesRecords}
                    attributeList={attributeList}
                    selectFirstRecord={true}
                    inserting={inserting}
                    updating={updating}
                />
            </LoadingIndicator>
        </Panel>
    );
}

export default Rules;